const HorizontalSpace = ({size}) => {
	return (
		<>
			<div className="Horizontal-space" style={{ padding: `${size}px 0px` }}></div>
		</>
	)
}

export default HorizontalSpace